import { ControlBooleanProperty, ControlStringProperty } from '../../../../../common/models/forms.model';
import { Validators } from '@angular/forms';
import { OrganizationModel } from './organization.model';

export class OrganizationDetailsModel {
  id?;
  hasMasterOfRolesUsers?: boolean;
  active = true;
  organizationName = '';
  country = '';
  city = '';
  streetName = '';
  streetNumber = '';
  zipCode = '';
  masterOfRoles = false;

  constructor(params?: OrganizationDetailsModel | OrganizationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class OrganizationDetailsForm {
  id?;
  hasMasterOfRolesUsers?;
  constructor(
    detailsModel: OrganizationDetailsModel,
    public organizationName: ControlStringProperty = [detailsModel.organizationName, [Validators.required]],
    public active: ControlBooleanProperty = [detailsModel.active, [Validators.required]],
    public masterOfRoles: ControlBooleanProperty = [detailsModel.masterOfRoles, [Validators.required]],
    public country: ControlStringProperty = [detailsModel.country, [Validators.required]],
    public city: ControlStringProperty = [detailsModel.city, [Validators.required]],
    public zipCode: ControlStringProperty = [detailsModel.zipCode, [Validators.required]],
    public streetName: ControlStringProperty = [detailsModel.streetName, [Validators.required]],
    public streetNumber: ControlStringProperty = [detailsModel.streetNumber, [Validators.required]],
  ) {
    if (detailsModel.id) {
      this.id = [detailsModel.id, []];
    }
    if (detailsModel.hasMasterOfRolesUsers) {
      this.hasMasterOfRolesUsers = [detailsModel.hasMasterOfRolesUsers, []];
    }
  }
}
